var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.08,25.51a2.5,2.5,0,0,0,2.5,2.5h5.6a2.5,2.5,0,0,0,0-5h-5.6A2.5,2.5,0,0,0,71.08,25.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66,25.51a2.5,2.5,0,0,0,2.5,2.5h5.6a2.5,2.5,0,0,0,0-5h-5.6A2.5,2.5,0,0,0,32.66,25.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.67,9.1V3.5a2.5,2.5,0,0,0-5,0V9.1a2.5,2.5,0,1,0,5,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71,8.18l-4,4a2.5,2.5,0,0,0,3.54,3.54l4-4A2.5,2.5,0,0,0,71,8.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.57,16.41a2.5,2.5,0,0,0,1.77-4.27l-4-4a2.5,2.5,0,0,0-3.54,3.54l4,4A2.49,2.49,0,0,0,45.57,16.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.52,45.24a5,5,0,0,0-5,5V94a5,5,0,0,0,5,5H30a5,5,0,0,0,5-4.65l3.1,1.86a19,19,0,0,0,9.77,2.71H69a18.45,18.45,0,0,0,7.44-1.48c6.75-3,7.81-8.27,7.31-11.77A11,11,0,0,0,87,73.45a10.92,10.92,0,0,0,2.5-7.21,10.48,10.48,0,0,0-2.05-5.69,9.17,9.17,0,0,0-2.29-10.48q-.31-.29-.65-.55a9.51,9.51,0,0,0-3.84-1.7l-.11,0c-6.63-1.41-11.09-1.5-17.65-1.5-.25-1.51-.24-4.68,1.74-10.65,1.83-5.53,1.67-10.1-.48-13.59a11.29,11.29,0,0,0-8.07-5.14l-.31,0a5.29,5.29,0,0,0-5.15,3.74,2.52,2.52,0,0,0-.08.36l-.75,5.4a16.1,16.1,0,0,1-1.4,4.68L41.12,46.43a8.59,8.59,0,0,1-6.12,5V50.24a5,5,0,0,0-5-5Zm0,48.76V50.24H30V94Zm20-37.54a13.53,13.53,0,0,0,10.1-8l7.23-15.27a21.08,21.08,0,0,0,1.83-6.14L55.45,22a.27.27,0,0,1,.13-.07,6.35,6.35,0,0,1,4.31,2.78c1.32,2.14,1.32,5.39,0,9.39-1.94,5.84-2.54,10.45-1.8,13.71a4.52,4.52,0,0,0,4.44,3.52h0c6.61,0,10.69.06,17,1.39l.1,0a4.6,4.6,0,0,1,1.85.78l.32.27c2.56,2.31.94,5.27.6,5.82a2.5,2.5,0,0,0,.44,3.21,5.93,5.93,0,0,1,1.69,3.66,6.87,6.87,0,0,1-2.25,4.87,2.5,2.5,0,0,0-.33,3c.11.19,2.68,4.66-2.41,8.4a2.54,2.54,0,0,0-.89,2.84c.27.8,1.33,4.9-4.16,7.31A13.49,13.49,0,0,1,69,93.92H47.83a14,14,0,0,1-7.19-2L35,88.54v-32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.76,
    cy: 86.22,
    r: 3.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUp);
export default __webpack_public_path__ + "static/media/icon-thumbs-up.1444006deaf24d902fbc7f316daa360e.svg";
export { ForwardRef as ReactComponent };